module.exports = __webpack_public_path__ + "static/media/computer.aa0165e8.svg";